const stats = [
  { value: "99.9%", label: "Uptime" },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Image */}
          <div className="w-full lg:w-[45%] flex-shrink-0">
            <div className="relative rounded-3xl overflow-hidden" style={{ height: "480px" }}>
              <img
                src="https://public.readdy.ai/ai/img_res/4a35827a442032bd2816a26a1c8fbbe9.jpg"
                alt="GRUNDAL d.o.o. team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-[55%]">
            <p className="text-xs uppercase tracking-[0.25em] text-gray-400 font-medium mb-4">
              About Us
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
              A Team of iOS<br />Experts
            </h2>
            <p className="text-gray-500 text-lg leading-relaxed mb-6">
              <strong>GRUNDAL d.o.o.</strong> is a dedicated team of specialists focused on developing
              modern, high-performance applications for the iOS platform. We combine deep technical
              expertise with a passion for clean, intuitive design.
            </p>
            <p className="text-gray-500 text-lg leading-relaxed mb-10">
              Our mission is to deliver products that genuinely improve the daily digital lives of our
              users — from protecting their privacy online to keeping their devices running at peak
              performance. Every line of code we write reflects our commitment to quality and security.
            </p>

            {/* Stats */}
            <div className="flex gap-6">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl font-bold text-gray-900 mb-1">{s.value}</div>
                  <div className="text-xs text-gray-400 uppercase tracking-wide">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
